module.exports = __webpack_public_path__ + "img/suggestion.2fbf37f5.svg";